import { Checkbox, FormControlLabel } from '@material-ui/core';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import RichTextEditor from 'components/RichTextEditor/RichTextEditor';
import { NoteEntityTypes } from './notesConsts';

export const NoteContent = ({
    viewByClient,
    content,
    onChange,
    hideViewByClient,
    showInReport = null,
    entityType = null,
    style,
    maxLength = null,
    plainTextLength = 0,
}) => {
    return (
        <>
            <RichTextEditor onChange={(val) => onChange('content', val)} content={content} style={style} />
            {maxLength !== null && (
                <div style={{ textAlign: 'right', fontSize: 11, color: '#888', marginTop: 2 }}>
                    {plainTextLength} / {maxLength}
                </div>
            )}
            <Authorize profile={permissionProfiles.NOTES.VIEW_BY_CLIENT}>
                {!hideViewByClient && <div>
                    <FormControlLabel
                        control={<Checkbox checked={viewByClient}
                            onChange={(e, value) => onChange('viewByClient', value)} />}
                        label="Note can be viewed by client" />
                </div>}
            </Authorize>
            {!hideViewByClient && <div>
                {(viewByClient === true && entityType == NoteEntityTypes.VEHICLE || entityType == NoteEntityTypes.ACTIVITY) && (
                    <FormControlLabel
                        control={<Checkbox checked={showInReport}
                            onChange={(e, value) => onChange('showInReport', value)} />}
                        label="Include Note in Export" />
                )}
            </div>}
        </>
    )
}